import { GzMegaMenuWebComponent } from './component/GzMegaMenuWebComponent';

export { GzMegaMenuWebComponent };
